// extracted by mini-css-extract-plugin
export var author = "testimonial-module--author--2d3fc";
export var authorTitle = "testimonial-module--authorTitle--de8b7";
export var avatarPlaceholder = "testimonial-module--avatarPlaceholder--5d4b5";
export var body = "testimonial-module--body--6172e";
export var paper = "testimonial-module--paper--79f17";
export var philAvatarPlaceholder = "testimonial-module--phil-Avatar-placeholder--2bfcc";